import React from "react";
import { Typography } from "@mui/material";
import { tokens } from "../../Common/designTokens";

const infoTooltipTypographySx = {
	color: tokens.colors.white,
	fontSize: "12px",
	lineHeight: 1.4,
	mb: "4px",
};
const strategyTooltipTypographySx = {
	...infoTooltipTypographySx,
	// already 12px via spread
};
export const marketAxessStrategyInfoContent = (
	<>
		<Typography sx={strategyTooltipTypographySx}>
			<b>Take</b>- High-urgency strategy that aggressively sources liquidity to complete orders as fast as possible, prioritizing speed over price.
		</Typography>
		<Typography sx={strategyTooltipTypographySx}>
			<b>Seek</b>- Time-based strategy balancing price improvement and execution, becoming more aggressive as needed to finish on schedule.
		</Typography>
		<Typography sx={strategyTooltipTypographySx}>
			<b>Provide</b>- Low-urgency, passive strategy that posts liquidity to capture spread and improve price rather than execute immediately.
		</Typography>
	</>
);

export const pricingProcessInfoContent = (
	<>
		<Typography sx={infoTooltipTypographySx}>
			<b>OneStep</b> – Pricing and execution are determined together in a single automated action using
			current market conditions.
		</Typography>
		<Typography sx={infoTooltipTypographySx}>
			<b>Delayed Spot</b> – Execution occurs now, but the final price is set at 3:00 PM time.
		</Typography>
	</>
);
